exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  DROPIFY */\r\n.dropify-wrapper {\r\n    border: 1px solid #e4e9f0;\r\n    border-radius: 5px;\r\n}\r\n\r\n.dropify-wrapper:hover {\r\n    background-image: linear-gradient(-45deg, #f2f4f8 25%, transparent 25%, transparent 50%, #f2f4f8 50%, #f2f4f8 75%, transparent 75%, transparent);\r\n}\r\n\r\n.dropify-wrapper.disabled {\r\n    opacity: .5;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/dropify/dropify.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/dropify/dropify.css
// module chunks = styles